<div
  class="top-fix resize-index flex flex-col justify-start items-center"
  [ngClass]="inModalMode ? '' : 'page-container h-screen w-screen center-screen'">
  @if (newOrganizationForm) {
    <div
      class="w-[25rem] flex flex-col gap-[1.25rem] px-[1.5rem] py-[2rem] scale-[3] lg:scale-100"
      [formGroup]="newOrganizationForm"
      [ngClass]="inModalMode ? '!py-0 !px-0' : 'white-card'">
      <span class="font-1 bold500 self-center">New organization</span>
      <app-input
        data-qa="new-org-name"
        tabindex="1"
        [required]="true"
        [autofocus]="true"
        [formControlName]="'name'"
        [title]="'Organization name'"
        [placeholder]="'Organization name'"
        [maxLength]="256"
      />
      <app-selector
        class="scale-3"
        data-qa="new-org-type"
        [listEntryAdditionalClass]="'font-4'"
        [title]="'Type'"
        [formControlName]="'type'"
        [data]="Array.from(organizationTypes.values())"
        [triggerOnValueChange]="true"
        [selectedItem]="organizationTypes.get(newOrganizationForm.value.type)"
        [defaultPlaceholder]="'Select'"
        [isRequired]="true"
        (itemEmitter)="newOrganizationForm.controls.type.setValue(reversedOrganizationTypes.get($event))"
      />
      <app-selector-autocomplete
        data-qa="new-org-country"
        class="height-15 full-picker-width"
        [formControlName]="'country'"
        [title]="'Country'"
        [data]="countries"
        [placeholder]="'Select'"
        [selectedItem]="newOrganizationForm.value.country"
      />
      <app-input
        data-qa="new-org-website"
        [formControlName]="'website'"
        [title]="'Website (Optional)'"
        [prefixText]="newOrganizationForm.value.website.includes('http') ? '' : 'https://'"
      />
      <app-button
        data-qa="new-org-continue"
        class="self-stretch"
        [type]="'accent'"
        [disabled]="!newOrganizationForm.valid"
        [bordersSquaredShape]="'full'"
        [size]="'large'"
        [additionalClasses]="'w-full'"
        (buttonClick)="continue()">
        Continue
      </app-button>
    </div>
  }
</div>
